import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAudioSchema } from '../../services/AudioSchemaService';
import { AudioSchema } from '../../types/AudioSchemas';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAudioSchema(fleetId: string, id: string): UseQueryResult<AudioSchema> {
  return useQuery(
    ['audio-schemas', fleetId, id],
    async (): Promise<AudioSchema> => getAudioSchema(fleetId, id),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: id !== '',
      refetchOnWindowFocus: false,
      // refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetAudioSchema;
